import {asyncRouterMap, constantRouterMap} from '@/router/index';
import store from '@/store/index.js'
import { getCompanyId } from "@/utils/auth.js";

//判断是否有权限访问该菜单
function hasPermission(menus, route, mymenus) {
  if (route.name) {
    let currMenu = getMenu(route.name, menus, mymenus);
    if (currMenu != null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title;
      }
      /*      if (currMenu.icon != null && currMenu.title !== '') {
              route.meta.icon = currMenu.icon;
            } */
      if (currMenu.hidden != null) {
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort;
      }
      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        return true;
      } else {
        return false;
      }
    }


  } else {
    return true
  }
}


//根据路由名称获取菜单
function getMenu(name, menus, item) {

  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name === menu.uri) {
      return menu;
    }
  }
  //如果只有一级给他添加第一个子菜单
  if (item) {
    if (item.level == 0) {
      for (let i = 0; i < menus.length; i++) {
        let menu = menus[i];

        if (item.name === menu.uri) {
          return menus[0];
        }
      }
    }
  }

  return null;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if (router.children && router.children.length > 0) {
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//检查用户是否有通知权限
function checkNotificationPermission(routers) {
  // 查找path为"/dataFolder"的路由
  const dataFolderRoute = routers.find(route => route.path === '/dataFolder');
  
  if (dataFolderRoute && dataFolderRoute.children) {
    // 在children中查找path为"word"的子路由
    const wordRoute = dataFolderRoute.children.find(child => child.path === 'word');
    return !!wordRoute; // 转换为布尔值
  }
  
  return false;
}

//升序比较函数
function compare(p) {
  return function (m, n) {
    let a = m[p];
    let b = n[p];
    return a - b;
  }
}

// 剔除没有子菜单的父菜单
function handleMenus(menus) {
   const filters = menus.filter(item => item.parentId === "0");
  filters.forEach(item => {
    const isTrue = menus.some(itemSon => itemSon.parentId === item.id);
    if(!isTrue) {
      const index = menus.findIndex(itemSon => itemSon.id === item.id);
      if(index !== -1) menus.splice(index, 1);
    }
  })
  return menus;
}

// 如果后端返回的 menus 没有富文本工具菜单，而accessedRouters有这个菜单，那么移除它，其他情况直接返回accessedRouters
function filterRouterItem(accessedRouters, menus) {
  const isTrue = menus.some(item => item.name === "富文本工具");
  if(!isTrue) {
    const findItemInside = accessedRouters.find(item => {
      if(typeof item === "object" && typeof item.meta === "object") {
        return item.meta.title === "调养方案";
      }else return false;
    });
    if(findItemInside) {
      if(typeof findItemInside === "object" && Array.isArray(findItemInside.children)) {
        const index = findItemInside.children.findIndex(item =>  {
        if(typeof item === "object" && typeof item.meta === "object") {
            return item.meta.title === "富文本工具";
          }else return false;
        });
        if(index !== -1) findItemInside.children.splice(index, 1);
      }
    }
  }
  return accessedRouters;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    hasNotificationPermission: false // 通知权限状态
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {

      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
      
      // 检查并设置通知权限
      state.hasNotificationPermission = checkNotificationPermission(state.routers);
    }
  },
  actions: {
    GenerateRoutes({commit}, data) {
      return new Promise(resolve => {
        let {menus} = data;
        // 只要打印版本不是 H5，那么都去掉 "报告管理" 菜单，华见公司账号除外
        if(getCompanyId() !== "fbb6b1d36f585c73ce1e03b778077deb" && store.getters.printVersion !== 1) {
          const index = menus.findIndex(item => item.name === "报告管理");
          if(index !== -1) menus.splice(index, 1);
        }
        menus = handleMenus(menus);
        const {username} = data;
        let accessedRouters = asyncRouterMap.filter(v => {
          //admin帐号直接返回所有菜单
          if (username === 'admin') return true;

          if (hasPermission(menus, v, '')) {
            if (v.children && v.children.length > 0) {

              v.children = v.children.filter(child => {
                if (hasPermission(menus, child, v)) {
                  return child
                }
                return false;
              });
              return v
            } else {

              return v
            }

          }
          return false;
        });
        accessedRouters = filterRouterItem(accessedRouters, menus);
        //对菜单进行排序
        sortRouters(accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      })
    }
  }
};

export default permission;




// WEBPACK FOOTER //
// ./src/store/modules/permission.js